import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MediaType } from '@app/store/shared/models';
import { TYPE_CHIP_CONFIGS } from '@shared/types/chip.type';

@Component({
    selector: 'app-select-media-type',
    templateUrl: './select-type.component.html',
    styleUrls: ['./select-type.component.css'],
    imports: [TranslateModule],
})
export class SelectMediaTypeComponent {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly translateService = inject(TranslateService);

    readonly types: { label: string; value: MediaType; icon: string }[];

    constructor() {
        const parentParams = this.route.parent?.snapshot.params ?? {};
        const rawType = <string>(parentParams['mediaType'] ?? '');
        const mediaTypes = <MediaType[]>rawType.split(',').filter(Boolean);

        this.types = mediaTypes.map((value) => ({
            value,
            label: this.translateService.instant(`media.type.${value}`),
            icon: TYPE_CHIP_CONFIGS[value]?.icon ?? 'pi pi-question',
        }));
    }

    selectType(type: MediaType): void {
        this.router.navigate(['../upload', type], { relativeTo: this.route });
    }

    goBack(): void {
        this.router.navigate(['../'], { relativeTo: this.route });
    }

    close(): void {
        const outlet = this.route.parent?.outlet ?? 'dialog';
        this.router.navigate([{ outlets: { [outlet]: null } }]);
    }
}
